import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../api';
import { ClientInfo } from '../model';

@Injectable()
export class ClientInfoDataSourceService {
  private authorizationService = inject(AuthenticationService);

  public connect(idp: string): Observable<ClientInfo> {
    return this.authorizationService.getClientInfo(idp);
  }
}
